import { useMemo } from 'react';
import { ImplementationGroup } from '@constants/entities/project';
import { useGetQnousRefsQuery } from '@store/services/qnous-ref';
import { getEntryTier } from '@utils/implementationGroup';

const useCisTierMap = (): Map<string, ImplementationGroup> => {
  const { data } = useGetQnousRefsQuery();

  return useMemo(() => {
    const entries =
      data?.cis?.reduce(
        (acc, { id, implementation_group }) => {
          const tier = getEntryTier(implementation_group);

          return tier ? acc.concat([[id, tier]]) : acc;
        },
        [] as Array<[string, ImplementationGroup]>,
      ) ?? [];

    return new Map(entries);
  }, [data]);
};

export default useCisTierMap;
